import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <React.Fragment>
    <circle cx="12" cy="8" r="6" stroke="inherit" strokeWidth="1"/>
  </React.Fragment>,
  "CircleIcon"
);